<div class="entity-config-page container-fluid px-0 py-0 py-lg-1">
  <div class="entity-config-shell d-flex flex-column gap-4 gap-lg-3 mx-auto">
    <div class="d-inline-flex rounded-4 border bg-white p-1 shadow-sm align-self-start">
      <button
        type="button"
        class="btn btn-sm rounded-3 px-4 py-2 fw-semibold"
        :class="is_forms_tab ? 'btn-primary-dark text-white' : 'btn-light text-secondary border-0 bg-transparent'"
        @click="set_active_tab('forms')"
      >
        Forms
      </button>
      <button
        type="button"
        class="btn btn-sm rounded-3 px-4 py-2 fw-semibold"
        :class="!is_forms_tab ? 'btn-primary-dark text-white' : 'btn-light text-secondary border-0 bg-transparent'"
        @click="set_active_tab('workflows')"
      >
        Workflows
      </button>
    </div>

    <section class="entity-config-top mb-1 rounded-4 overflow-hidden shadow-sm">
      <div class="entity-config-top-hero px-2 px-md-3 py-3">
        <div class="d-flex justify-content-between align-items-start gap-3">
          <div>
            <h1 class="entity-page-title text-white fw-bold lh-sm mb-1">
              {{ banner_title }}
            </h1>
            <p class="entity-page-subtitle text-white mb-0">
              {{ banner_subtitle }}
            </p>
          </div>

          <button
            type="button"
            class="btn btn-primary-dark text-xs d-inline-flex align-items-center rounded-3 px-3 py-2 shadow-sm"
            data-bs-toggle="modal"
            :data-bs-target="banner_action_target"
            @click="handle_banner_action"
          >
            <i class="bi bi-plus-circle-fill me-2 text-white"></i>
            <span>{{ banner_action_label }}</span>
          </button>
        </div>
      </div>
    </section>

    <section class="card border-0 shadow-sm rounded-4 overflow-hidden">
      <template v-if="is_forms_tab">
      <div class="card-body p-3 p-md-4">
        <div v-if="is_loading" class="text-center text-secondary p-4">
          <div class="fw-semibold text-x mb-1">Loading template forms...</div>
        </div>

        <div v-else-if="!has_forms" class="text-center text-secondary p-4">
          <div
            class="rounded-circle bg-primary-subtle text-primary d-inline-flex align-items-center justify-content-center mb-3 p-3 lh-1"
          >
            <i class="bi bi-ui-checks-grid fs-5"></i>
          </div>
          <div class="fw-semibold text-x mb-1">No template forms found</div>
          <div class="text-xs">
            Use the <b>Create New Form</b> button to add your first template form.
          </div>
        </div>

        <template v-else>
          <div
            class="entity-table-head secondary-color d-none d-lg-block rounded-3 mb-2 px-3 py-2 text-uppercase tracking-wide"
          >
            <div class="row g-2 align-items-center">
              <div class="col-lg-5">Form</div>
              <div class="col-lg-2">Status</div>
              <div class="col-lg-2">Created</div>
              <div class="col-lg-3 text-end">Actions</div>
            </div>
          </div>

          <div class="d-flex flex-column gap-2">
            <article
              v-for="form in template_forms"
              :key="form.template_form_id"
              class="entity-row-card bg-white rounded-4 border border-purple border-opacity-50 shadow-sm p-2"
            >
              <div class="row g-2 align-items-center">
                <div class="col-12 col-lg-5 d-flex align-items-center gap-3">
                  <div
                    class="entity-type-icon entity-icon-surface rounded-3 d-inline-flex align-items-center justify-content-center flex-shrink-0"
                  >
                    <i class="bi bi-ui-checks-grid"></i>
                  </div>

                  <div class="min-w-0">
                    <div class="fw-bold text-x text-truncate">
                      {{ form.form_name || 'Untitled Form' }}
                    </div>
                    <div class="text-secondary text-xs text-wrap text-break">
                      {{ form.form_description || 'Used for template onboarding mapping.' }}
                    </div>
                  </div>
                </div>

                <div class="col-12 col-sm-4 col-lg-2">
                  <span
                    class="entity-status-pill d-inline-flex align-items-center justify-content-center fw-bold text-uppercase"
                    :class="form.is_active !== false ? 'entity-status-active text-primary' : 'bg-white border text-secondary'"
                  >
                    {{ form.is_active !== false ? 'active' : 'inactive' }}
                  </span>
                </div>

                <div class="col-12 col-sm-5 col-lg-2 text-xs text-secondary">
                  <i class="bi bi-calendar3 me-2"></i>
                  {{ format_date(form.created_at) }}
                </div>

                <div class="col-12 col-sm-3 col-lg-3 d-flex justify-content-lg-end gap-2">
                  <button
                    type="button"
                    class="btn entity-assign-btn btn-sm rounded-small px-2 py-1"
                    data-bs-toggle="modal"
                    data-bs-target="#assign_onboarding_form_modal"
                    @click="open_assign_modal(form)"
                  >
                    Assign
                  </button>
                  <button
                    type="button"
                    class="btn entity-assign-btn btn-sm rounded-small  px-2 py-1"
                    @click="open_mapping(form)"
                  >
                    Manage
                  </button>
                  <button
                    type="button"
                    class="btn entity-assign-btn btn-sm rounded-small  px-2 py-1"
                    data-bs-toggle="modal"
                    data-bs-target="#edit_template_form"
                  
                    @click="open_edit_modal(form)"
                  >
                    Edit
                  </button>
                </div>
              </div>
            </article>
          </div>
        </template>
      </div>
      </template>

      <div v-else class="card-body p-3 p-md-4">
        <EsigningWorkflows ref="esigningWorkflows" />
      </div>
    </section>
  </div>

  <teleport to="body">
    <div
      class="modal fade"
      id="assign_onboarding_form_modal"
      tabindex="-1"
      aria-labelledby="assign_onboarding_form_modal_label"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-white rounded-4 p-0 shadow-lg">
          <div class="modal-header border-bottom-0 cute-header shadow-lg">
            <p class="modal-title text-white text-xs mb-0" id="assign_onboarding_form_modal_label">
              Link onboarding forms
              <span v-if="selected_assign_template_form_name" class="fw-normal ms-1">
                {{ selected_assign_template_form_name }}
              </span>
            </p>
            <button
              type="button"
              class="modal-btn-close btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>

          <div class="modal-body">
            <div
              v-if="is_loading_onboarding_forms || is_loading_assignments"
              class="text-secondary text-xs"
            >
              Loading onboarding forms...
            </div>

            <div v-else class="d-flex flex-column gap-3">
              <div
                v-for="onboarding_form in onboarding_forms"
                :key="onboarding_form.id"
                class="border rounded-4 shadow-sm px-3 py-3 d-flex align-items-start justify-content-between gap-3"
              >
                <div class="min-w-0">
                  <div class="fw-semibold text-x text-break">
                    {{ onboarding_form.title }}
                  </div>
                  <div class="text-secondary text-xs text-break mt-1">
                    {{ onboarding_form.description || 'No description provided.' }}
                  </div>
                  <div
                    v-if="is_onboarding_form_assigned(onboarding_form.id)"
                    class="text-primary text-xxs fw-semibold mt-2"
                  >
                    Assigned
                  </div>
                </div>

                <div class="form-check form-switch m-0 pt-1">
                  <input
                    :id="`onboarding-form-switch-${onboarding_form.id}`"
                    class="form-check-input"
                    type="checkbox"
                    role="switch"
                    :checked="is_onboarding_form_assigned(onboarding_form.id)"
                    :disabled="is_submitting_assignment"
                    @change="submit_onboarding_form_assignment(onboarding_form.id)"
                  />
                </div>
              </div>

              <div
                v-if="!onboarding_forms.length"
                class="text-secondary text-xs"
              >
                No onboarding forms found.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </teleport>

  <teleport to="body">
    <div
      class="modal fade"
      id="create_template_form"
      tabindex="-1"
      aria-labelledby="create_template_form_label"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-white rounded-4 p-0 shadow-lg">
          <div class="modal-header border-bottom-0 cute-header shadow-lg">
            <p class="modal-title text-white text-xs mb-0" id="create_template_form_label">
              Create Template Form
            </p>
            <button
              type="button"
              class="modal-btn-close btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>

          <div class="modal-body">
            <div class="mb-3">
              <label for="template_form_name" class="form-label fw-bold text-xs">
                Form name
              </label>
              <input
                id="template_form_name"
                v-model.trim="form_name"
                type="text"
                class="form-control text-xs"
                placeholder="My Template Form"
              />
            </div>

            <div class="mb-3">
              <label for="template_form_description" class="form-label fw-bold text-xs">
                Description
              </label>
              <input
                id="template_form_description"
                v-model.trim="form_description"
                type="text"
                class="form-control text-xs"
                placeholder="Used for template onboarding mapping"
              />
            </div>
          </div>

          <div class="modal-footer border-0 p-2 d-flex justify-content-end gap-2">
            <button
              type="button"
              class="btn btn-primary-dark btn-sm text-xs"
              @click="save_template_form"
              :disabled="is_saving"
            >
              {{ is_saving ? 'Saving...' : 'Save' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </teleport>


  <teleport to="body">
    <div
      class="modal fade"
      id="edit_template_form"
      tabindex="-1"
      aria-labelledby="edit_template_form_label"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-white rounded-4 p-0 shadow-lg">
          <div class="modal-header border-bottom-0 cute-header shadow-lg">
            <p class="modal-title text-white text-xs mb-0" id="edit_template_form">
              Edit Template Form
            </p>
            <button
              type="button"
              class="modal-btn-close btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>

          <div class="modal-body">
           <div class="mb-3">
              <label for="template_form_name" class="form-label fw-bold text-xs">
                Form name
              </label>
              <input
                id="template_form_name"
                v-model="edit_form_name"
                type="text"
                class="form-control text-xs"
               
              />
            </div>

            <div class="mb-3">
              <label for="template_form_description" class="form-label fw-bold text-xs">
                Description
              </label>
              <input
                id="template_form_description"
                v-model="edit_form_description"
                type="text"
                class="form-control text-xs"
                
              />
            </div>
          </div>

          <div class="modal-footer border-0 p-2 d-flex justify-content-end gap-2">
            <button
              type="button"
              class="btn btn-primary-dark btn-sm text-xs"
              @click="update_template_form()"
              :disabled="is_updating"
            >
              {{ is_updating ? 'Updating...' : 'Update' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</div>
